module.exports = __webpack_public_path__ + "img/sold.8fd0e807.svg";